import { Link, SxProps, Theme, useTheme } from '@mui/material'
import { useNavigate } from 'react-router-dom'

export type LinkToProps = {
  title: string | JSX.Element
  url: string
  color?: string
  external?: boolean
  underline?: boolean
  sx?: SxProps<Theme>
  'data-cy'?: string
} | {
  title: string | JSX.Element
  color?: string
  onClick: () => void
  underline?: boolean
  sx?: SxProps<Theme>
  'data-cy'?: string
}

/**
 * Display a number (W) as kilo watts (kW) or emdash if no number.
 */
export const LinkTo = (props: LinkToProps): JSX.Element => {
  const { title, underline, sx, color } = props
  const theme = useTheme()
  const navigate = useNavigate()

  const onClick = () => {
    if ('url' in props) {
      if (props.external) {
        window.open(props.url, '_blank')
      } else {
        navigate(props.url)
      }
    } else {
      props.onClick()
    }
  }

  return (
    <Link
      onClick={onClick}
      color={color || theme.palette.grey[400]}
      underline={underline ? 'always' : 'hover'}
      data-cy={`link-${title}`}
      sx={{
        ...sx,
        cursor: 'pointer'
      }}
    >
      {title}
    </Link>
  )
}
